import { RenewalOrderStatus } from '@appTypes/enums';
import { Program, packRosterModuleName } from '@shared/constants';

export const moduleName = packRosterModuleName;

export const SELECTABLE_PEOPLE_LIMIT = 30;

export const confirmationWord = 'yes';
export const UNASSIGNED = 'unassigned';

export const peopleFilters = Object.freeze({
  YOUTH: 'showYouth',
  AGED_YOUTH: 'showAgedYouth',
  ADULTS: 'showAdults',
  DEN_CHIEFS: 'showDenChiefs',
});

export const visibilityFields = Object.freeze({
  AGE: 'age',
  MEMBER_ID: 'memberId',
  LAST_RANK_EARNED: 'lastRankEarned',
  SUB_UNIT: 'subUnit',
});

export const programGrownUpAges = Object.freeze({
  [Program.VENTURING]: 18,
  [Program.EXPLORING]: 18,
  [Program.CLUB]: 18,
  [Program.BOY_SCOUT]: 18,
  [Program.SEA_SCOUT]: 18,
  //
  [Program.CUB_SCOUT]: 18,
  [Program.VARSITY]: 18,
});

export const UNIT_PARTICIPANT = 'Unit Participant';

export const YOUTH_MEMBER = 'Youth Member';

export const importantPositions = [
  'Scoutmaster',
  'Venturing Crew Advisor',
  'Skipper',
  'Cubmaster',
  'Committee Chair',
  'Committee Chairman',
  'Chartered Organization Rep.',
];

export const renewalStatuses = {
  OPTED_OUT: 'Opted Out',
  RENEWED: 'Renewed',
  ELIGIBLE_TO_RENEW: 'Eligible to Renew',
  CURRENT: 'Current',
} as const;

export const registrationSituationStatuses = {
  ACTIVE: 'activeRegistration',
  LAPSED: 'lapsedRegistration',
  EXPIRED: 'expiredRegistration',
} as const;

export const defaultFilter = {
  [peopleFilters.YOUTH]: true,
  [peopleFilters.AGED_YOUTH]: true,
  [peopleFilters.ADULTS]: true,
  [peopleFilters.DEN_CHIEFS]: true,
  [renewalStatuses.CURRENT]: true,
  [renewalStatuses.ELIGIBLE_TO_RENEW]: true,
  [renewalStatuses.OPTED_OUT]: true,
  [renewalStatuses.RENEWED]: true,
  [registrationSituationStatuses.EXPIRED]: false,
  [registrationSituationStatuses.LAPSED]: true,
  [registrationSituationStatuses.ACTIVE]: true,
  // By default all order status = true
  ...Object.fromEntries(
    Object.keys(RenewalOrderStatus).map(key => [`order_status_${key}`, true]),
  ),
} as const;

export const PACK_ROSTER_FILTERS = 'PACK_ROSTER_FILTERS';
